module.exports = __webpack_public_path__ + "static/img/founder.446ea0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/about-us/founder.svg
// module id = 1RP/
// module chunks = 1